<template>
  <div>
    <h2>Change Contact Information</h2>
  </div>
</template>

<script>

export default {
  name: 'ChangeContactInfo',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s3accountSettings/ChangeContactInfo.vue